import TemplateView from '../../../../../TemplateView'
import DocumentsLinksList from './DocumentsLinksList'
import AddressChangesNote from './AddressChangesNote'

export default class PurchaseSuccessContent extends TemplateView {
    constructor() {
        super()

        this.state = {
            titleText: '',
            effectTitleText: '',
            hostingZone: '',
            isHostingZoneChanged: false,
            context: '',
            isContextChanged: false,
            titleNoteText: '',
            documentsNoteText: '',
            documentUrls: {
                serviceAgreementUrl: null,
                dataProcessingAgreementUrl: null,
                serviceAgreementExhibitUrl: null,
                invoiceUrl: null,
            },
            documentsBaseUrl: '',
        }

        this.onStatePropertyChanged('titleText', (titleText) => this.$title.text(titleText))
        this.onAnyStatePropertyChanged([
            'hostingZone',
            'isHostingZoneChanged',
            'context',
            'isContextChanged',
        ], () => this._addressWasChangedHandler())
        this.onStatePropertyChanged('titleNoteText', (titleNoteText) => this.$titleNote.text(titleNoteText))
        this.onStatePropertyChanged('effectTitleText', (effectTitleText) => this.$effectTitle.text(effectTitleText))
        this.onStatePropertyChanged('documentsNoteText', (documentsNoteText) => this.$documentsNote.text(documentsNoteText))

        this.onStatePropertyChanged('documentUrls', (documentUrls) => {
            this.documentsLinksList.setState({documentUrls})
            const hasDocuments = Object.values(documentUrls).some((url) => !!url)
            this.getEl().toggleClass('noDocuments', !hasDocuments)
        })

        this.onStatePropertyChanged('documentsBaseUrl', (documentsBaseUrl) => {
            this.documentsLinksList.setState({documentsBaseUrl})
        })
    }

    templateHtml() {
        return '<div class="purchaseSuccessContainer">' +
               '    <div class="img"/>' +
               '    <div class="purchaseTitle"/>' +
               '    <div class="addressChangesNote"/>' +
               '    <div class="titleNote"/>' +
               '    <div class="effectTitle"/>' +
               '    <div class="documentsNote"/>' +
               '    <div class="documentsLinksList"/>' +
               '</div>'
    }

    afterRender() {
        this.$title = this.find('.purchaseTitle')
        this.$titleNote = this.find('.titleNote')
        this.$effectTitle = this.find('.effectTitle')
        this.$documentsNote = this.find('.documentsNote')

        this.addressChangesNote = new AddressChangesNote({noteTextKey: 'licenses.purchase.success.purchase_title_change_address_note.title'})
            .init(this.find('.addressChangesNote'))

        this.documentsLinksList = new DocumentsLinksList().init(this.find('.documentsLinksList'))
    }

    _addressWasChangedHandler() {
        this.addressChangesNote.setState({
            hostingZone: this.state.hostingZone,
            isHostingZoneChanged: this.state.isHostingZoneChanged,
            context: this.state.context,
            isContextChanged: this.state.isContextChanged,
        })

        this.getEl().toggleClass('noAddressChanges', !(this.state.isContextChanged || this.state.isHostingZoneChanged))
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/purchaseLightBox/successStep/PurchaseSuccessContent.js